<template lang="pug">
  .form-item(:class="{'-error-': error}")
    span.form-item__title(v-if="title")
      | {{title}}

    .form-item__block(v-click-outside="close")

      span.form-item__error(v-if="error")
        | Нужно выбрать группу

      .form-item__select.select(@click="toggleOpen" :class="{'-error__class-': error}")
        .form-item__input.select-custom(v-if="filteringData.length > 0")
          | {{selectedText ? selectedText : placeholder}}
        .form-item__input.select-custom(v-else)
          .lesson-block__ajax.ajax__line
      SlideUpDown.select__slider(
        :duration="slideDuration"
        :active="isOpen"
      )
        .select__field
          .form-item__select.select.position-relative.margin-bottom-20
            input.form-item__input.select__input(
              v-model="searchingText"
              @focus="focus"
              @blur="blur"
              placeholder="Поиск группы"
            )
            Icon(
              class="form-item__delete"
              icon="input-delete"
              @click="clearInput"
            )

          .folders-select__list(
            v-for="(item, itemIdx) in filteringData" :key="itemIdx+'folder'"
          )
            SelectItem(
              :data="item"
              :margin="5"
              v-model="selectedData"
            )


      Icon.select__icon.form-item__icon(
        :icon="!icon ? 'arrow-down' : icon"
        @click="toggleOpen"
        :class="{'-opened-': isOpen}"
      )

</template>

<script>
import _ from 'lodash';
import SlideUpDown from 'vue-slide-up-down';
import vClickOutside from 'v-click-outside';
import SelectItem from './SelectItem';
import { mapState, mapActions } from 'vuex';

export default {
  name: 'Select',
  components: {
    SlideUpDown,
    SelectItem
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  props: {
    title: {},
    placeholder: {},
    error: {},
    icon: {},
    path: {},
    value: {}
  },
  data() {
    return {
      isOpen: false,
      slideDuration: 200,
      status: false,
      selectText: '',
      data: [],
      searchingText: '',
      selectedData: [],
      isFocus: false
    };
  },
  computed: {
    ...mapState('msg', {
      folders: s => s.data.folders
    }),
    selectedText() {
      // Текст для выбранного значения селекта
      let str = '';
      const data = this.selectedData;

      data.forEach((item, idx) => {
        if (data.length - 1 === idx) {
          str += item.name;
        } else {
          str += item.name + ', ';
        }
      });
      return str;
    },
    filteringData() {
      return this.data
        .map(data => {
          const newObject = {
            folder: data.folder
          };
          if (data.groupArray && data.groupArray.length) {
            newObject.groupArray = data.groupArray.filter(
              el =>
                el.name
                  .toUpperCase()
                  .indexOf(this.searchingText.toUpperCase()) > -1
            );
          }
          if (data.childrenFolders && data.childrenFolders.length) {
            newObject.childrenFolders = data.childrenFolders.filter(el =>
              el.groupArray.find(
                elem =>
                  elem.name
                    .toUpperCase()
                    .indexOf(this.searchingText.toUpperCase()) > -1
              )
            );
          }

          if (
            (newObject.groupArray && newObject.groupArray.length > 0) ||
            (newObject.childrenFolders && newObject.childrenFolders.length > 0)
          ) {
            return newObject;
          }
        })
        .filter(el => el);
    }
  },
  watch: {
    folders() {
      this.data = _.cloneDeep(this.folders);
      this.rebuildData();
    },
    selectedData() {
      if (!this.isFocus) {
        this.$emit(
          'input',
          this.selectedData.map(el => el.id)
        );
      }
    }
  },
  beforeMount() {
    this.getGroups();
  },
  mounted() {
    this.data = _.cloneDeep(this.folders);
    if (this.data && this.data.length) {
      this.rebuildData();
    }
  },
  methods: {
    ...mapActions('msg', ['getGroups']),
    toggleData(value) {
      this.selectedData = value;
      this.rebuildData(true);
      this.data = _.cloneDeep(this.filteringData);
      this.toggleOpen();
    },
    rebuildData(value) {
      this.filteringData.forEach(item => {
        this.reqFunction(item, value);
      });
    },
    reqFunction(data, isFalse) {
      if (
        data.groupArray &&
        data.groupArray.length &&
        data.groupArray.length >= 1
      ) {
        for (let i = 0; i < data.groupArray.length; i++) {
          if (!isFalse) {
            if (
              this.value.length > 0 &&
              this.value.some(el => el == data.groupArray[i].id)
            ) {
              this.selectedData.push(data.groupArray[i]);
              data.groupArray[i].checked = true;
            } else {
              data.groupArray[i].checked = false;
            }
          } else {
            data.groupArray[i].checked = false;
          }
        }

        if (!isFalse) {
          if (data.groupArray.every(el => el.checked)) {
            data.folder.checked = true;
          } else {
            data.folder.checked = false;
          }
        } else {
          data.folder.checked = false;
        }

        if (
          data.childrenFolders &&
          data.childrenFolders.length &&
          data.childrenFolders.length >= 1
        ) {
          for (let i = 0; i < data.childrenFolders.length; i++) {
            this.reqFunction(data.childrenFolders[i], isFalse);
          }
        }
      }
    },
    toggleOpen() {
      if (this.folders.length > 0) {
        this.isOpen = !this.isOpen;
      }
    },
    focus() {
      this.isFocus = true;
    },
    blur() {
      this.isFocus = false;
    },
    close() {
      this.isOpen = false;
    },
    clearInput() {
      this.searchingText = '';
      this.selectedData = [];
      this.rebuildData(true);
    }
  }
};
</script>
